import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import MainCard from 'components/Cards/MainCard';
import { gridSpacing } from 'utils/constants';
import ApiHelper from 'utils/apiHelper';
import PageHeader from 'components/Layout/PageHeader';

const ManagementLicenses = () => {
    const { userInfo } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(true);
    const manageOrganizationData = useSelector((state) => state.management.organization?.selected);
    const [licenseData, setLicenseData] = useState([]);
    const [totalLicenses, setTotalLicenses] = useState(0);
    const [usedLicenses, setUsedLicenses] = useState(0);

    useEffect(() => {
        setLoading(true);
        ApiHelper.get(`/api/management/licenses/`)
            .then((res) => {
                setLicenseData(res.data.results);
                setTotalLicenses(res.data.total_licenses);
                setUsedLicenses(res.data.used_licenses);
                setLoading(false);
            })
            .catch((err) => {
                if (err.response.status !== 401) {
                    toast.error('Failed to get the licenses data');
                    setLoading(false);
                }
            });
    }, []);

    if (!licenseData) {
        return null;
    } else {
        return (
            <MainCard title="License Management" cardHeaderShow={false}>
                <Grid container spacing={gridSpacing}>
                    <Grid item xs={12}>
                        <PageHeader
                            title={manageOrganizationData?.orgid ? manageOrganizationData.name : userInfo.user.orgid.name}
                            paddingNum={2}
                        />
                        <Grid container spacing={gridSpacing}>
                            <Grid item lg={12} xs={12}>
                                {loading === true ? (
                                    <Typography sx={{ mt: 3, textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}>
                                        Please wait...
                                    </Typography>
                                ) : licenseData.length === 0 ? (
                                    <Typography sx={{ mt: 3, textAlign: 'center' }}>No Licenses Data</Typography>
                                ) : (
                                    <Table sx={{ minWidth: 700 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Organization</TableCell>
                                                <TableCell>Type</TableCell>
                                                <TableCell>Total</TableCell>
                                                <TableCell>Used</TableCell>
                                                <TableCell>Remaining</TableCell>
                                                <TableCell>Issued</TableCell>
                                                <TableCell>Expiration</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {licenseData
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map((data, key) => (
                                                    <TableRow key={key}>
                                                        <TableCell>{data.name}</TableCell>
                                                        <TableCell>{data.type}</TableCell>
                                                        <TableCell>{data.total}</TableCell>
                                                        <TableCell>{data.used}</TableCell>
                                                        <TableCell>{data.total - data.used}</TableCell>
                                                        <TableCell>{data.issued}</TableCell>
                                                        <TableCell>{data.expiration}</TableCell>
                                                    </TableRow>
                                                ))}
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell>{totalLicenses}</TableCell>
                                                <TableCell>{usedLicenses}</TableCell>
                                                <TableCell>{totalLicenses - usedLicenses}</TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </MainCard>
        );
    }
};

export default ManagementLicenses;
